import { NavLink, Outlet } from 'react-router-dom';

const SECTIONS = [
  {
    label: 'People',
    links: [
      { to: '/admin/users', label: 'Users' },
      { to: '/admin/domains', label: 'Allowed email domains' },
    ],
  },
  {
    label: 'Surveillance',
    links: [
      { to: '/admin/monitored-tags', label: 'Monitored tags' },
      { to: '/admin/monitored-keywords', label: 'Monitored keywords' },
      { to: '/admin/config', label: 'Surveillance config' },
      { to: '/admin/saved-views', label: 'Saved & shared views' },
      { to: '/admin/announcements', label: 'Announcements' },
    ],
  },
  {
    label: 'Observability',
    links: [
      { to: '/admin/monitoring', label: 'Overview' },
      { to: '/admin/activity-feed', label: 'Activity feed' },
      { to: '/admin/reverse-lookup', label: 'Who viewed wallet X' },
      { to: '/admin/trace-requests', label: 'Trace requests' },
      { to: '/admin/audit', label: 'Admin audit log' },
      { to: '/admin/system', label: 'System / ingestion health' },
    ],
  },
];

export function AdminLayout() {
  return (
    <div className="admin-layout">
      <nav className="admin-nav" aria-label="Admin sections">
        {SECTIONS.map((s) => (
          <div key={s.label}>
            <div className="admin-nav__group-label">{s.label}</div>
            {s.links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) => `admin-nav__link${isActive ? ' is-active' : ''}`}
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
      <div>
        <Outlet />
      </div>
    </div>
  );
}
